import React, { useEffect, useRef, useState } from "react";
import { Modal } from "@mantine/core";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";
import CustomButton from "../../components/CustomButton";


const DocuSignModal = ({
  isOpen,
  onRequestClose,
  signUrl,
  handleIframeClose,
}) => {
  const [backdropopen, setbackdropopen] = useState(false);
  const [showContinueBtn,setShowContinueBtn]=useState(false)

  useEffect(() => {
    const onMessage = (event) => {
      if (event.data?.type === "IFRAME_URL_CHANGED") {
        console.log("Iframe URL changed to:", event.data.url);
        // Do whatever you need here
        if (event.data.url.includes("postsigning")) {
       setShowContinueBtn(true)
      }
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);


    useEffect(() => {
    if (isOpen) {
      setShowContinueBtn(false);
    }
  }, [isOpen]);

  const handleLoad = () => {
    setbackdropopen(false);
  };

  const handleClose = () => {
    setShowContinueBtn(false)
    handleIframeClose();
    onRequestClose();
  };

  // useEffect(() => {
  //   if (signUrl) {
  //     setbackdropopen(true);
  //   }
  // }, []);

  const [opened, { open, close }] = useDisclosure(false);

  const iframeRef = useRef(null);
  const [iframeUrl, setIframeUrl] = useState("");

  const handlePostSigning = () => {
    console.log("Post-signing page loaded!");
    // Your custom logic here...
  };

  const onIframeLoad = () => {
    setbackdropopen(false);

    // const iframe = iframeRef.current;

    // if (!iframe) return;

    // try {
    //   // ⚠️ We can't read iframe.contentWindow.location (cross-origin),
    //   // but we CAN read iframe.src safely.
    //   const currentUrl = iframe.src;
    //   setIframeUrl(currentUrl);

    //   console.log("Current iframe URL:", currentUrl);

    //   if (currentUrl.includes("postsigning")) {
    //     handlePostSigning();
    //   }
    // } catch (err) {
    //   console.warn("Cannot access iframe content due to cross-origin.");
    // }
  };

  //   useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (iframeRef.current) {
  //       const url = iframeRef.current.src;
  //       // if (url.includes("postsigning")) {
  //       //   handlePostSigning();
  //       //   clearInterval(interval);
  //       // }

  //       console.log(url)
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);
  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: "3000" }} open={backdropopen}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Modal
        opened={isOpen}
        onClose={() => {
          setShowContinueBtn(false);
          
          onRequestClose()
        }}
        fullScreen
        withCloseButton={false}
        
        transitionProps={{ transition: "slide-up" }}
        padding={0}

      >
        <div style={{ height: "60px", background: "#fff", display: "flex", justifyContent: "flex-end" ,paddingRight:"20px",alignItems:"center"}}>
          
          <Close width={'40px'} height={'40px'} onClick={() => {
            setShowContinueBtn(false)
            onRequestClose()
           }} />

        </div>
        {
          showContinueBtn &&  <div className="d-flex justify-content-end signature-modal-btn" >
          
          <button
            onClick={handleClose}
            className="signature-btn"
           
          >
            Please press to continue
          </button>
        </div>
        }
       
        {/* <div className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{ marginBottom: "10px" }}
          >
            Close
          </Button>
        </div> */}
        {signUrl ? (
          <iframe
            src={signUrl}
            ref={iframeRef}
            title="Wesign"
            width="100%"
            height="90%"
            onLoad={onIframeLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </>
  );
};

export default DocuSignModal;
